import { Component, EventEmitter, Input, OnChanges, OnDestroy, Output, SimpleChanges } from '@angular/core';
import { ProductService } from '../product.service';
import { VisibilityChannel } from '../model/visibilityGroup.model';
import { AppMainService } from 'src/app/app-main.service';
import { SharedChannelService } from 'src/app/modules/shared/services/channel.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { ColumnSettingsN } from 'src/app/modules/shared/models/column-settings.model';
import { SharedColumnSettingsService } from 'src/app/modules/shared/services/column-settings.service';
import { ConfirmationService, MessageService } from 'primeng/api';
import { VisibilityGroupService } from 'src/app/configurations/users/visibility-group/services/visibility-group.service';
import { AccountModuleId, ProductModuleId } from 'src/app/modules/shared/constants/modules.constant';
import { AccountHelper } from './../../../../accounts-v2/services/accounts.helper';
import { SavedSearchNS } from 'src/app/misc/saved-searches/models/saved-search.models';
import { Visibility } from '../model/visibilityGroup.model';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AppMainComponent } from 'src/app/app.main.component';
import { Status, ObjectNames } from '../../constants/constants';
import { SavedFilterData } from 'src/app/modules/shared/models/filter.model';
import { ConfigurationService } from 'src/app/configurations/configurationService';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-visibility',
  templateUrl: './visibility.component.html',
  styleUrls: ['./visibility.component.scss']
})
export class ProductVisibilityComponent implements OnChanges , OnDestroy {

  @Input() displayAddGroup: boolean = false;
  @Input() index: number = 0;
  @Output() closeDialog = new EventEmitter();
  visibilityGroups: Visibility[] = [];
  filterCols = []
  groupForm: FormGroup;
  addFlag: boolean = true;
  invalidData: boolean = false;
  fromAccount: boolean = false;
  preview: boolean = false;
  accountForm: FormGroup;
  productForm: FormGroup;
  fromRule: boolean = false;
  savedFilterData: SavedFilterData;
  radioOptions = [
    { label: 'Manually', value: true },
    { label: 'using Rule Logic', value: false }
  ];
  addEditGroupHeader;
  displayProductList = false;
  displayAddAccounts = false;
  allModules: any[] = [];
  allChannels: VisibilityChannel[] = [];
  moduleColumnSetttings: Partial<ColumnSettingsN> = {};
  manualHeaderTitle: string = "Data List";
  displayModuleDataList: boolean = false;
  selectedRecordList: any[] = [];
  totalRecords: number = 0;
  pageSize: number = 15;
  loadingTable: boolean;
  tableShowMore: number[] = [15, 30, 50, 100];
  expandedRows: any = [];
  isFromView = false;
  ruleData: SavedSearchNS.IRuleList[] = [];
  ruleList: SavedSearchNS.IRuleList[] = [];

  /* Subject to unsubscribe */
  protected ngUnsubscribe$: Subject<void> = new Subject<void>();

  constructor(private productconfigService: ProductService,
    private appMainService: AppMainService, private fb: FormBuilder,
    private sharedChannelService: SharedChannelService, private datePipe: DatePipe,
    private columnSettingsService: SharedColumnSettingsService, private configService: ConfigurationService,
    private messageService: MessageService, private app: AppMainComponent, private accountHelper: AccountHelper,
    private visibilityGroupService: VisibilityGroupService, private confirmationService: ConfirmationService) { }


  ngOnChanges(changes: SimpleChanges): void {
    this.prepareGroupForm();
    this.prepareAccountForm();
    if (changes?.displayAddGroup?.currentValue) {
      this.displayAddGroup = changes?.displayAddGroup?.currentValue;
      this.addGroup();
    }
    if (changes?.index?.currentValue) {
      this.getAllVisibilityGroups();
    }
  }

  getAllVisibilityGroups() {
    this.productconfigService.getProductVisibilityGroups().pipe(takeUntil(this.ngUnsubscribe$)).subscribe((groups: Visibility[]) => {
      this.visibilityGroups = groups?.map(gp => ({
        ...gp,
        isActive: gp.statusId === 1,
        updatedDate: this.app._showDateTimeWithZone(new Date(gp.updatedDate))
      })) ?? [];
    })
  }

  prepareGroupForm() {
    this.groupForm = this.fb.group({
      id: [0],
      createdSource: [this.app.userIP],
      updatedSource: [this.app.userIP],
      createdBy: [this.app.userId],
      updatedBy: [this.app.userId],
      createdDate: [new Date().toISOString()],
      updatedDate: [new Date().toISOString()],
      groupName: ['', [Validators.required, Validators.pattern(/^(?!\s*$).+/)]],
      description: [''],
      statusId: [true],
      isDefault: [false],
      organizationId: [this.app.companyId]
    })
  }

  addGroup() {
    this.addEditGroupHeader = "Add Product Visibility Group";
    this.addFlag = true;
    this.invalidData = false;
    // this.displayAddGroup = true;
  }

  editGroup(value) {
    this.prepareGroupForm();
    this.addEditGroupHeader = "Edit Product Visibility Group";
    value.statusId = value.statusId === Status.ACTIVE;
    this.addFlag = false;
    this.invalidData = false;
    this.groupForm.patchValue(value);
    this.displayAddGroup = true;
  }

  saveGroup(value) {
    this.appMainService.isShowSpinner("add");
    value.statusId = value.statusId ? Status.ACTIVE : Status.INACTIVE;
    if (this.addFlag) {
      const lowerCaseNames = [];
      for (let s of this.visibilityGroups) {
        lowerCaseNames.push(s.groupName.toLowerCase().replace(/ /g, ''))
      }
      if (lowerCaseNames.indexOf(value.groupName.toLowerCase().replace(/ /g, '')) > -1) {
        this.invalidData = true;
        this.appMainService.isHideSpinner("add");
        return;
      }
      this.productconfigService.addVisibilityGroup(value).pipe(takeUntil(this.ngUnsubscribe$))
        .subscribe({
          next: (res) => {
            this.appMainService.isHideSpinner("add");
            this.getAllVisibilityGroups();
            this.closeDialog.emit();
            this.messageService.add({ severity: "success", summary: "Success", detail: "Data added successfully..." });
          },
          error: (error) => {
            this.appMainService.isHideSpinner("add");
            this.closeDialog.emit();
            this.messageService.add({ severity: "error", summary: "Error", detail: `${error.error.Message}` });
          }
        });
    } else {
      const duplicateRecord = this.visibilityGroups?.find(depOb => depOb.groupName?.toLowerCase() == value.groupName.toLowerCase() && depOb.id !== value.id);
      if (duplicateRecord) {
        this.invalidData = true;
        this.appMainService.isHideSpinner("add");
        return;
      }
      this.productconfigService.updateVisibilityGroup(value).pipe(takeUntil(this.ngUnsubscribe$))
        .subscribe({
          next: (res) => {
            this.appMainService.isHideSpinner("add");
            this.getAllVisibilityGroups();
            this.closeDialog.emit();
            this.messageService.add({ severity: "success", summary: "Success", detail: "Data updated successfully..." });
          },
          error: (error) => {
            this.appMainService.isHideSpinner("add");
            this.closeDialog.emit();
            this.messageService.add({ severity: "error", summary: "Error", detail: `${error.error.Message}` });
          }
        });
    }
    this.displayAddGroup = false;
  }

  hideDialog() {
    this.groupForm.reset();
    this.displayAddGroup = false;
    this.closeDialog.emit();
  }

  makeVisibilityGroupDefault(group) {
    this.appMainService.isShowSpinner("default");
    if (group.isDefault) {
      this.productconfigService.setDefaultVisibilityGroup(group.id).pipe(takeUntil(this.ngUnsubscribe$))
        .subscribe({
          next: (res) => {
            this.appMainService.isHideSpinner("default");
            this.getAllVisibilityGroups();
            this.messageService.add({ severity: "success", summary: "Success", detail: "Data updated successfully..." });
          },
          error: (error) => {
            this.appMainService.isHideSpinner("default");
            group.isDefault = false;
            this.messageService.add({ severity: "error", summary: "Error", detail: `${error.error.Message}` });
          }
        });
    }
  }

  deleteGroup(groupId, index) {
    this.confirmationService.confirm({
      message: 'Do you want to delete this visibility group?',
      header: 'Delete Confirmation',
      icon: 'pi pi-info-circle',
      accept: () => {
        this.appMainService.isShowSpinner("delete");
        this.productconfigService.deleteVisibilityGroup(groupId).pipe(takeUntil(this.ngUnsubscribe$))
          .subscribe({
            next: (res) => {
              this.appMainService.isHideSpinner("delete");
              this.visibilityGroups?.splice(index, 1);
              this.messageService.add({ severity: "success", summary: "Success", detail: "Data deleted successfully..." });
            },
            error: (error) => {
              this.appMainService.isHideSpinner("delete");
              this.messageService.add({ severity: "error", summary: "Error", detail: `${error.error.Message}` });
            }
          });
      },
      reject: () => {
      }
    });
  }

  prepareAccountForm() {
    this.accountForm = this.fb.group({
      visibilityGroupId: [0],
      moduleId: [{ value: null, disabled: true }, [Validators.required]],
      channelId: [null, [Validators.required]],
      selectAll: [false],
      ruleId: [true]
    })
  }

  addVisibility(group, child, fromView) {
    this.appMainService.isShowSpinner("getGroup");
    this.prepareAccountForm();
    this.ruleData = [];
    this.selectedRecordList = [];
    if (child.text == "Product") {
      this.fromAccount = false;
      this.allModules = [
        {
          objectId: ProductModuleId,
          name: "Product"
        },
      ];
    } else if (child.text == "Account") {
      this.fromAccount = true;
      this.allModules = [
        {
          objectId: AccountModuleId,
          name: "Account"
        },
      ];
    }
    this.accountForm.controls['moduleId'].setValue(this.allModules[0]);
    this.accountForm.controls['visibilityGroupId'].setValue(group.id);
    this.productconfigService.getVisibilityRuleByGroupId(group.id, child.text === 'Account').pipe(takeUntil(this.ngUnsubscribe$))
      .subscribe({
        next: (res) => {
          this.appMainService.isHideSpinner("getGroup");
          if (res) {
            if (child.text == 'Account') {
              this.accountForm.controls['selectAll'].setValue(res.showAllAccounts);
              this.accountForm.controls['ruleId'].setValue(res.isManualAccount);
              if (!res.isManualAccount) {
                const savedRule = res.accountRulesJson && JSON.parse(res.accountRulesJson);
                this.ruleData = savedRule?.filterInColumns ?? [];
                this.savedFilterData = { filter: savedRule?.filterInColumns ?? [], groupByFieldId: null }
              }
              this.getChannels(this.accountForm.controls['moduleId']?.value?.objectId, res.channelId, fromView);
              this.selectedRecordList = [];
              this.selectedRecordList = Array.isArray(res.productVisibilityGroupAccount)
                ? res.productVisibilityGroupAccount.map(account => ({
                  ...account,
                  id: account.accountId // Use `null` as a fallback
                }))
                : [];
            } else {
              this.accountForm.controls['selectAll'].setValue(res.showAllProducts);
              this.accountForm.controls['ruleId'].setValue(res.isManualProduct);
              if (!res.isManualProduct) {
                const savedRule = res.productRulesJson && JSON.parse(res.productRulesJson);
                this.ruleData = savedRule?.FilterInColumns ?? [];
                this.savedFilterData = { filter: savedRule?.FilterInColumns ?? [], groupByFieldId: null }
              }
              this.getProductChannels('product', res.productTypeId, fromView);
              this.selectedRecordList = res.productVisibilityGroupProduct ?? [];
            }
          } else {
            if (child.text == 'Account') {
              this.getChannels(this.accountForm.controls['moduleId']?.value?.objectId, null, fromView);
            } else {
              this.getProductChannels('product', null, fromView);
            }
          }
        },
        error: (error) => {
          this.appMainService.isHideSpinner("getGroup");
        }
      });
  }


  getProductChannels(moduleName, savedParam, fromView) {
    this.configService.getConfigurationByModuleName(moduleName).subscribe(configs => {
      const typeConfig = configs.filter(s => s.name == ObjectNames.productConstants.Inventory_Types_Object)[0];
      this.allChannels = JSON.parse(typeConfig.configurationDetails[0].configJSONValue);
      let selectedChannel = null;
      if (savedParam) {
        selectedChannel = this.allChannels.find(x => x?.id == savedParam);
        this.accountForm.controls['channelId'].setValue(selectedChannel);
      } else {
        selectedChannel = this.allChannels.find(x => x?.isDefault);
        this.accountForm.controls['channelId'].setValue(selectedChannel);
      }
      this.getProductColumnSetting(this.accountForm.controls['channelId'].value?.id, fromView);
    });
  }

  getAssignedModuleRecord(moduleId, visibilityGroupId): void {
    this.appMainService.isShowSpinner('getAssignedModuleRecord');
    this.visibilityGroupService.getAssignedModuleRecordMinified(moduleId, visibilityGroupId)
      .pipe(takeUntil(this.ngUnsubscribe$))
      .subscribe({
        next: (response) => {
          this.selectedRecordList = response || [];
          this.appMainService.isHideSpinner('getAssignedModuleRecord');
        },
        error: ((error) => {
          this.appMainService.isHideSpinner('getAssignedModuleRecord');
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: error?.error?.Message ? error?.error?.Message : 'Assigned user group not found, please try again later..'
          });
        }),
        complete: (() => {
        })
      });
  }

  cancelProductAdd() {
    this.displayProductList = false;
  }

  onProductAddComplete() {
    this.displayProductList = false;
  }

  getChannels(selectedModuleId: number, savedParam, fromView: boolean): void {
    this.appMainService.isShowSpinner('getChannel');
    this.sharedChannelService.getChannels(selectedModuleId)
      .pipe(takeUntil(this.ngUnsubscribe$))
      .subscribe(
        {
          next: (response) => {
            this.allChannels = Array.isArray(response)
              ? response.map(ip => ({
                ...ip,
                objectId: this.accountForm.controls['moduleId']?.value?.objectId ?? null // Use `null` as a fallback
              }))
              : [];
            let selectedChannel = null;
            if (savedParam) {
              selectedChannel = this.allChannels.find(x => x?.id == savedParam);
              this.accountForm.controls['channelId'].setValue(selectedChannel);
            } else {
              selectedChannel = this.allChannels.find(x => x?.isDefault);
              this.accountForm.controls['channelId'].setValue(selectedChannel);
            }
            this.appMainService.isHideSpinner('getChannel');
            this.getColumnSetting(selectedModuleId, selectedChannel?.id, fromView);
          },
          error: (error) => {
            this.appMainService.isHideSpinner('getChannel');
            this.messageService.add({
              severity: 'error',
              summary: 'Error',
              detail: error?.error?.message ? error?.error?.message : 'Channels are not loaded, please try again...'
            });
          }
        });
  }

  getColumnSetting(moduleId: number, channelId: number, fromView: boolean) {
    this.moduleColumnSetttings.listViewSections = [];
    this.appMainService.isShowSpinner("getColumnSetting");
    this.columnSettingsService
      .getColumnSettings(moduleId, channelId)
      .pipe(takeUntil(this.ngUnsubscribe$))
      .subscribe({
        next: (response) => {
          this.moduleColumnSetttings = response;
          this.filterCols = this.accountHelper.getSectionWiseFlatCols(this.moduleColumnSetttings?.listViewSections || []);
          this.appMainService.isHideSpinner("getColumnSetting");
          if (fromView) {
            this.getDataLists(true);
          } else {
            this.displayAddAccounts = true;
          }
          this.isFromView = fromView;
        },
        error: (error) => {
          this.appMainService.isHideSpinner("getColumnSetting");
          this.messageService.add({
            severity: "error",
            summary: "Error",
            detail: error?.error?.message
              ? error?.error?.message
              : "Column settings are not loaded, please try again...",
          });
        },
        complete: () => { },
      });
  }

  getProductColumnSetting(channelId: number, fromView: boolean) {
    this.appMainService.isShowSpinner("getColumnSetting");
    this.productconfigService.getProductColumnSettings(channelId).pipe(takeUntil(this.ngUnsubscribe$)).subscribe({
      next: (response) => {
        this.filterCols = response.map(obj => ({
          ...obj, // Spread the existing properties
          typeId: channelId // Add the new field
        })) || [];
        this.appMainService.isHideSpinner("getColumnSetting");
        if (fromView) {
          this.getDataLists(true);
        } else {
          this.displayAddAccounts = true;
        }
        this.isFromView = fromView;
      },
      error: (error) => {
        this.appMainService.isHideSpinner("getColumnSetting");
        this.messageService.add({
          severity: "error",
          summary: "Error",
          detail: error?.error?.message
            ? error?.error?.message
            : "Column settings are not loaded, please try again...",
        });
      },
      complete: () => { },
    });
  }

  getDataLists(preview) {
    this.manualHeaderTitle = "Data Lists";
    this.preview = preview;
    this.fromRule = !this.accountForm.controls['ruleId'].value;
    if (this.accountForm.controls['moduleId'].value?.name == 'Account') {
      this.displayModuleDataList = true;
    } else {
      this.displayProductList = true;
    }
  }

  backToModuleClicked() {
    this.displayModuleDataList = false;
    this.displayAddAccounts = true;
  }

  applyFilters(event) {
    console.log(event.selectedFilter)
    if (event.selectedFilter) {
      this.ruleData = [...event.selectedFilter];
    } else {
      this.ruleData = [];
    }
  }

  transformData(values) {
    if (values?.length > 0) {
      const firstValue = values[0];
  
      // Strict check for valid date string (ISO format or similar) and exclude numbers
      if (this.isValidDateString(firstValue)) {
        return values.map((val) => {
          return this.isValidDateString(val)
            ? this.datePipe.transform(val, 'MM/dd/yyyy') || val
            : val;
        });
      } else {
        return values.join(', '); // Join non-date values
      }
    }
    return null; // Handle empty or undefined values
  }
  
  isValidDateString(value: any): boolean {
    return (
      typeof value === 'string' && // Only allow strings
      /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.\d{3}Z$/.test(value) && // Strict ISO format check
      !isNaN(Date.parse(value)) // Ensure it's a valid date
    );
  }
  

  setAccountData(moduleName: string, accountList) {
    if (moduleName == 'Account') {
      return accountList?.map(acc => acc.id) ?? [];
    } else {
      return accountList?.map(acc => acc.productId) ?? [];
    }
  }

  saveAssignData(accountData, e) {
    this.appMainService.isShowSpinner("add");
    const req = {
      productVisibilityGroupId: accountData.visibilityGroupId,
      objectRecordIdList: (accountData.ruleId && !accountData.selectAll) ? this.setAccountData(accountData.moduleId?.name, e.selectedReccords) : [],
      moduleTypeId: accountData.moduleId?.objectId,
      channelId: this.fromAccount ? accountData.channelId?.id : 0,
      channelName: this.fromAccount ? accountData.channelId?.name : 0,
      productTypeId: !this.fromAccount ? accountData.channelId?.id : 0,
      productTypeName: !this.fromAccount ? accountData.channelId?.name : 0,
      showAllAccounts: this.fromAccount ? accountData.selectAll : false,
      showAllProducts: !this.fromAccount ? accountData.selectAll : false,
      filterRules: [],
      accountRulesJson: (this.fromAccount && this.fromRule) ? e.accountPayLoad : '',
      productRulesJson: (!this.fromAccount && this.fromRule) ? e.productPayLoad : '',
    }
    this.productconfigService.addVisibilityData(req, this.fromAccount).pipe(takeUntil(this.ngUnsubscribe$))
      .subscribe({
        next: (res) => {
          this.appMainService.isHideSpinner("add");
          this.displayAddAccounts = false;
          this.displayModuleDataList = false;
          this.displayProductList = false;
          this.getAllVisibilityGroups();
          this.messageService.add({ severity: "success", summary: "Success", detail: "Data added successfully..." });
        },
        error: (error) => {
          this.appMainService.isHideSpinner("add");
          this.displayAddAccounts = false;
          this.displayModuleDataList = false;
          this.messageService.add({ severity: "error", summary: "Error", detail: `${error.error.Message}` });
        }
      });
  }

  cancelClickedModuleDataList() {
    this.displayModuleDataList = false;
    this.displayAddAccounts = true;
    if (this.isFromView) {
      this.displayAddAccounts = false;
    }
  }

  onChannelChange(event) {
    if (!(this.accountForm.controls['ruleId'].value || this.accountForm.controls['selectAll'].value)) {
      const moduleName = this.accountForm.controls['moduleId'].value?.name;
      const moduleObjectId = this.accountForm.controls['moduleId'].value?.objectId;
      const channelId = this.accountForm.controls['channelId'].value?.id;
      if (moduleName === 'Account') {
        this.getColumnSetting(moduleObjectId, channelId, false);
      } else {
        this.getProductColumnSetting(channelId, false);
      }
    }
    this.selectedRecordList = [];
    this.savedFilterData = { filter: [], groupByFieldId: null };
    this.applyFilters(event);
  }
   
  ngOnDestroy(): void {
    if (this.ngUnsubscribe$) {
      this.ngUnsubscribe$.next();
      this.ngUnsubscribe$.complete();
      this.ngUnsubscribe$.unsubscribe();
    }
  }

}
